<template>
  <div
    class="d-signup-modal modal modal-sm sign-up-modal"
    :class="{ 'active': isShown }"
  >
    <div class="overlay" />
    <div
      class="modal-content"
    >
      <a
        class="button button-icon button-close button-close-modal"
        @click="hide()"
      />

      <div class="modal-image">
        <img :src="images.header">
      </div>
      <div class="modal-body">
        <DSignupModalSignup />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import DSignupModalSignup from './d-signup-modal-signup/d-signup-modal-signup.vue';

export default {
  components: {
    DSignupModalSignup,
  },
  data: () => ({
    images: {
      header: require('@d-assets/great-story.svg'),
    },
    isShown: false,
  }),
  methods: {
    hide() {
      this.$set(this, 'isShown', false);
    },

    show() {
      this.$set(this, 'isShown', true);
      Vue.prototype.eventsTracking.addEventToCurrentChain('open-sign-up-modal');
    },
  },
};
</script>
